import React from 'react';

import Image from '../Image';

import './Awards.css';

export default function Awards() {
   const awardsData = [
      {
         src: "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/nxtwave-intensive-2.0/awards-section/awards-section-nasscom-mobile.svg",
         alt: "NASSCOM Award",
         className: "nasscom_img",
         width: 243,
         height: 53,
      },
      {
         src: "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/nxtwave-intensive-2.0/awards-section/awards-section-ministry-of-india-mobile.png",
         alt: "Ministry of India Award",
         className: "msi_img",
         width: 329,
         height: 54,
      },
      {
         src: "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/nxtwave-intensive-2.0/awards-section/awards-section-startup-india-mobile-mobile-mobile.svg",
         alt: "Startup India Award",
         className: "startupindia_img",
         width: 243,
         height: 54,
      },
      {
         src: "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/nxtwave-intensive-2.0/awards-section/awards-section-nsdc-mobile.svg",
         alt: "NSDC Award",
         className: "nsdc_img",
         width: 238,
         height: 54,
      }
   ];

   return (
      <section className='section_2'>
         <div className='div_block_8'>
            <div className='text_block_3'>RECOGNIZED BY</div>
            <div className='div_block_9'>
               {awardsData.map(({ src, alt, className, width, height }) => (
                  <Image
                     key={src}
                     src={src}
                     alt={alt}
                     className={className}
                     width={width}
                     height={height}
                  />
               ))}
            </div>
         </div>
      </section>
   );
}
